import * as React from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { useAppContext } from '../../contexts/AppContext';
import { LAYOUTADSCONFIGRATION_AC, LAYOUTADSCONFIGRATION_AC_BOTTOM } from '../../types/static';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useCursorContext } from '../../contexts/CursorContext';
import { AdvertisementSlot } from '../../components/AdvertisementSlot';

const SectionRight = styled('div')(({ theme }) => ({
  width: 332,
  marginTop: theme.spacing(7),
  paddingBottom: theme.spacing(4),
  paddingLeft: theme.spacing(4),
  '@media screen and (max-width: 1220px)': {
    display: 'none',
  },
}));

const AdvertisementSlotTop = styled(AdvertisementSlot)(({ theme }) => ({
  boxShadow: theme.shadows[0],
}));

const AdvertisementSlotBottom = styled(AdvertisementSlot)(({ theme }) => ({
  boxShadow: theme.shadows[0],
  marginTop: theme.spacing(4),
}));

const AdvertisementTop = ({ id }: any) => {
  return <AdvertisementSlotTop configuration={LAYOUTADSCONFIGRATION_AC} areaName="aLayoutRightTopAds" elevation={1} slotIdentifier={id || "idhb-right-300"} variant="300x600" />
}

const AdvertisementBottom = ({ id }: any) => {
  return <AdvertisementSlotBottom configuration={LAYOUTADSCONFIGRATION_AC_BOTTOM} areaName="aLayoutRightTopAds" elevation={1} slotIdentifier={id || "idhb-right-small-300"} variant="300x250" />
}

export const LayoutAds = () => {
  const router = useRouter();
  const appContext = useAppContext();
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up('lg'));
  const isBetweenMdAndLg = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const { componentOptions, project } = appContext.useConfig();
  const { panel } = useCursorContext();
  const header_lift = project.features.ads.header_lift;
  
  const [adsRequest, setAdsRequest] = React.useState<((adsList: string[]) => void) | null>(null);

  React.useEffect(() => {
    if (header_lift) {
      import('../../utils/ads-request').then(module => {
        setAdsRequest(module.adsRequest);
      });
    }
  }, [header_lift]);

  const layoutAdsElements: Record<string, boolean> = {
    'idhb-right-300': !(componentOptions.component_layout_right_ads_disabled || componentOptions.component_layout_right_tablet_ads_disabled || componentOptions.component_layout_right_ads_mobile_disabled),
    'idhb-right-small-300': !(componentOptions.component_layout_right_middle_ads_disabled || componentOptions.component_layout_right_middle_tablet_ads_disabled || componentOptions.component_layout_right_middle_mobile_ads_disabled),
  };

  const adsList = Object.keys(layoutAdsElements).filter(key => layoutAdsElements[key]);

  React.useEffect(() => {
    if (header_lift && adsRequest && adsList.length > 0) {
      adsRequest(adsList);
    }
  }, [adsRequest, adsList, header_lift]);

  React.useEffect(() => {
    if (!header_lift || !adsRequest) return;

    const { events } = router;
    const handleRouteChange = () => {
      if (adsList.length > 0 && !componentOptions.component_ads_disabled) {
        adsRequest(adsList);
      }
    };
  
    events.on('routeChangeComplete', handleRouteChange);
    events.on('hashChangeComplete', handleRouteChange);
  
    return () => {
      events.off('routeChangeComplete', handleRouteChange);
      events.off('hashChangeComplete', handleRouteChange);
    };
  }, [router, header_lift]);

  return (
    panel ? (
      <SectionRight>
        <AdvertisementTop />
        <AdvertisementBottom />
      </SectionRight>
    ) : (
      !componentOptions.component_ads_disabled && adsList.length > 0) && (
      <SectionRight>
        {(lg && !componentOptions.component_layout_right_ads_disabled) && <AdvertisementTop id={componentOptions.component_right_ads_id} /> }
        {(isBetweenMdAndLg && !componentOptions.component_layout_right_tablet_ads_disabled) && <AdvertisementTop id={componentOptions.component_right_ads_id} /> }
        {(mdDown && !componentOptions.component_layout_right_ads_mobile_disabled) && <AdvertisementTop id={componentOptions.component_right_ads_id} /> }

        {(lg && !componentOptions.component_layout_right_middle_ads_disabled) && <AdvertisementBottom id={componentOptions.component_right_middle_ads_id} /> }
        {(isBetweenMdAndLg && !componentOptions.component_layout_right_middle_tablet_ads_disabled) && <AdvertisementBottom id={componentOptions.component_right_middle_ads_id} /> }
        {(mdDown && !componentOptions.component_layout_right_middle_mobile_ads_disabled) && <AdvertisementBottom id={componentOptions.component_right_middle_ads_id} /> }
      </SectionRight>
    )
  );
};